import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';
import DataTable from "react-data-table-component";

interface IFormProps {
  setForEdit: any
}
interface MyStates {
  ajaxLoaded: number,
  services: any,
  defaultSortField: string,
  defaultSortAsc: boolean,
  search: string,
  sorting: object,
  totalRows: number,
  displayRows: number,
  currentPage: number,
  spinner: string
}
export default class ServicesDatatable extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      ajaxLoaded: 0,
      services: [], 
      sorting: {}, 
      totalRows: 0, 
      displayRows: 10, 
      currentPage: 1,
      defaultSortField: 'code', 
      defaultSortAsc: true, 
      search: '',
      spinner: 'flex'
    }
    this.loadservices()
  }

  private loadservices(filters = {}) {
    var ajax = new Ajax(window.location.origin + '/reservatio/szolgaltatasok/getServices');
    ajax.doPost({
      filters: filters, 
      limit: this.state.displayRows,
      offset: this.state.currentPage,
      sorting: this.state.sorting,
      search: this.state.search,
    }).then((response) => {
      this.setState({
        ajaxLoaded: Math.random(),
        services: response.services,
        totalRows: response.total_rows,
        spinner: 'none'
      }, () => this.props.setForEdit(0))
    })
  }
  private removeThis(id){
    swal({
        title: "Biztos, hogy törli ezt a szálláshelyet a listáról?",
        icon: "warning",
        buttons: {
            confirm: {
              text: "Igen",
              value: true,
              visible: true,
              className: "float-right btn-success",
              closeModal: true
            },
            cancel: {
              text: "Mégse",
              value: false,
              visible: true,
              className: "float-left btn-danger",
              closeModal: true,
            }
        }
    })
    .then((willDelete) => {
        if (willDelete) {
          this.setState({
            spinner: 'flex'
          }, () => {
            var ajax = new Ajax(window.location.origin + '/reservatio/szolgaltatasok/delete/'+id);
            ajax.doPost({}).then((response) => {
              this.loadservices()
            })
          })
        }
    });
  }

  private handlePerRowsChange(e){
    this.setState({
      displayRows: e,
      spinner: 'flex'
    }, () => this.loadservices())
  }

  private handlePageChange(e){
    this.setState({
      currentPage: e,
      spinner: 'flex'
    }, () => this.loadservices())
  }

  private search(e){
    this.setState({
      search: e.target.value,
      spinner: 'flex'
    }, () => this.loadservices())
  }
  private refresh(){
    this.setState({
      spinner: 'flex'
    }, () => this.loadservices())
  }

  private doSort(e, ordering){
    this.setState({
      sorting: {
        'column': e.selector,
        'ordering': ordering
      }, 
      defaultSortField: e.selector, 
      defaultSortAsc: ordering == 'asc' ? true : false,
      spinner: 'flex'
    }, () => this.loadservices())
  }

  public render() {
    const columns = [
      {
        width: '100px',
        name: 'Kód',
        selector: 'code',
        sortable: true,
        cell: row => row.code,
      },
      {
        width: '150px',
        name: 'Szolgáltatás',
        selector: 'service',
        sortable: true,
        cell: row => row.service,
      },
      {
        name: 'Megnevezés',
        selector: 'name',
        sortable: true,
        cell: row => row.name,
      },
      {
        width: '100px',
        name: 'Időtartam',
        selector: 'period',
        sortable: true,
        cell: row => row.period + ' perc',
      },
      {
        width: '150px',
        name: 'Ár',
        selector: 'price',
        sortable: true,
        cell: row => row.price + ' Ft / ' + row.unit,
      },
      {
        width: '125px',
        name: '',
        selector: 'menu',
        sortable: false,
        cell: row => {
          return (
          <>
            <button type="button" className="btn btn-success btn-sm" style={{marginRight: '10px'}} onClick={() => this.props.setForEdit(row.id)}><i className="fa fa-pencil"></i></button>
            {row.id != 45 &&
              <button type="button" className="btn btn-danger btn-sm" onClick={() => this.removeThis(row.id)}><i className="fa fa-trash"></i></button>
            }
          </>)
        },
      },
    ]

    const data = this.state.services
    
    return (
    <>
      <div className="box">
        <div className="box-header">
          <h3 className="box-title">Szolgáltatások</h3>
          <button type="button" className="btn btn-success btn-sm" onClick={() => this.refresh()}><i className="fa fa-refresh"></i></button>
          <input type="text" className="form-control" placeholder="Keresés..." onChange={(e) => this.search(e)} /> 
        </div>
        <div className="box-body table-responsive" style={{position: 'relative'}}>
          <div className="spinner-fill" style={{display: this.state.spinner}}>
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
          <DataTable 
            noHeader 
            pagination
            paginationServer
            keyField='efactory_item_id'
            defaultSortField={this.state.defaultSortField}
            defaultSortAsc={this.state.defaultSortAsc}
            paginationTotalRows={this.state.totalRows}
            paginationDefaultPage={this.state.currentPage}
            onChangeRowsPerPage={(e) => this.handlePerRowsChange(e)}
            onChangePage={(e) => this.handlePageChange(e)}
            columns={columns} 
            data={data} 
            onSort={(e,x) => this.doSort(e,x)} />
        </div>
      </div>
    </>
    )
  }
}